/* NUVEXILO Wishlist — local-device favorites, independent of paid apps. */
(function () {
  'use strict';
  const KEY='nuvexilo:wishlist:v1';
  const MAX=60;
  const HANDLE=/^[a-z0-9][a-z0-9_-]{0,160}$/i;
  const panel=document.getElementById('nxv-wishlist-panel');
  if(!panel)return;
  const root=(panel.dataset.shopRoot||'/').replace(/\/?$/,'/');
  const list=panel.querySelector('[data-nxv-wishlist-list]');
  const counter=panel.querySelector('[data-nxv-panel-count]');
  const toastEl=document.querySelector('[data-nxv-wishlist-toast]');
  const cache=new Map();
  let handles=[];
  let renderVersion=0;
  let toastTimeout=0;
  function validate(input){
    return Array.isArray(input)?Array.from(new Set(input.filter(x=>typeof x==='string'&&HANDLE.test(x)))).slice(0,MAX):[];
  }
  function read(){
    try{return validate(JSON.parse(localStorage.getItem(KEY)||'[]'))}catch(_){return []}
  }
  function write(next){
    try{localStorage.setItem(KEY,JSON.stringify(next));return true}catch(_){return false}
  }
  function el(tag,cls,content){
    const node=document.createElement(tag);
    if(cls)node.className=cls;
    if(content!==undefined)node.textContent=content;
    return node;
  }
  function showToast(message){
    if(!toastEl)return;
    toastEl.textContent=message;toastEl.hidden=false;
    clearTimeout(toastTimeout);
    toastTimeout=setTimeout(()=>{toastEl.hidden=true},2400);
  }
  function syncOne(button){
    const h=button.dataset.nxvWishlistHandle;
    if(!h)return;
    const saved=handles.includes(h);
    button.setAttribute('aria-pressed',String(saved));
    const title=button.dataset.nxvWishlistTitle||'this item';
    button.setAttribute('aria-label',(saved?'Remove ':'Save ')+title+(saved?' from wishlist':' to wishlist'));
    button.title=saved?'Remove from wishlist':'Save to wishlist';
    const txt=button.querySelector('.nxv-wishlist-heart__text');
    if(txt)txt.textContent=saved?'SAVED TO WISHLIST':'SAVE TO WISHLIST';
  }
  function syncControls(){
    document.querySelectorAll('[data-nxv-wishlist-handle]').forEach(syncOne);
    document.querySelectorAll('[data-nxv-wishlist-count]').forEach(node=>{
      node.textContent=String(handles.length);
      node.hidden=handles.length===0;
      node.setAttribute('aria-label',handles.length+' saved items');
    });
    counter.textContent=handles.length+' '+(handles.length===1?'ITEM':'ITEMS');
  }
  function toggle(handle){
    if(!HANDLE.test(handle))return;
    const saved=handles.includes(handle);
    const next=saved?handles.filter(x=>x!==handle):handles.concat(handle).slice(-MAX);
    if(!write(next)){showToast('Favorites cannot be saved in this browser. Check private browsing or storage settings.');return}
    handles=next;
    syncControls();
    showToast(saved?'Removed from your wishlist':'Saved to your wishlist');
    if(panel.open)renderPanel();
  }
  function href(handle){return root+'products/'+encodeURIComponent(handle)}
  async function loadProduct(handle){
    if(cache.has(handle))return cache.get(handle);
    try{
      const response=await fetch(href(handle)+'.js',{credentials:'same-origin'});
      if(!response.ok)throw new Error(String(response.status));
      const data=await response.json();
      if(!data||typeof data.title!=='string')throw new Error('Invalid product');
      cache.set(handle,data);return data;
    }catch(_){return null}
  }
  function money(cents){
    const value=Number(cents);
    if(!Number.isFinite(value))return '';
    const currency=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||(window.shopSettings&&window.shopSettings.isoCode)||'EUR';
    const locale=document.documentElement.lang||'en';
    try{return new Intl.NumberFormat(locale,{style:'currency',currency:currency}).format(value/100)}
    catch(_){return (value/100).toFixed(2)+' '+currency}
  }
  function pictureUrl(src){
    if(typeof src!=='string'||!src)return '';
    const url=src.startsWith('//')?location.protocol+src:src;
    return /^https?:\/\//i.test(url)?url:'';
  }
  function empty(){
    list.replaceChildren();
    const wrap=el('div','nxv-wishlist-panel__empty');
    const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
    svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('fill','none');svg.setAttribute('stroke','currentColor');svg.setAttribute('stroke-width','1.5');
    const path=document.createElementNS('http://www.w3.org/2000/svg','path');
    path.setAttribute('d','M20.8 4.9a5.5 5.5 0 0 0-7.8 0L12 6l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.2 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z');
    svg.append(path);
    wrap.append(svg,el('h3','', 'Nothing saved yet.'),el('p','', 'See something you love? Tap the heart to keep it here.'));
    const link=el('a','', 'EXPLORE THE COLLECTION');
    link.href=root+'collections/all';
    wrap.append(link);list.append(wrap);
  }
  function productCard(handle,prod){
    const article=el('article','nxv-wishlist-panel__item');
    const imageLink=el('a','nxv-wishlist-panel__photo');
    imageLink.href=href(handle);
    const src=prod?pictureUrl(prod.featured_image||(prod.images&&prod.images[0])):'';
    if(src){const im=el('img');im.src=src;im.loading='lazy';im.alt=prod.title;imageLink.append(im)}
    else imageLink.textContent='NUVEXILO';
    const body=el('div','nxv-wishlist-panel__details');
    const title=el('a','nxv-wishlist-panel__product-title',prod?prod.title:'Product unavailable');
    title.href=href(handle);
    body.append(title);
    if(prod){
      const price=el('div','nxv-wishlist-panel__price',money(prod.price));
      if(Number(prod.compare_at_price)>Number(prod.price)){price.append(el('s','',money(prod.compare_at_price)))}
      body.append(price);
    }
    const available=!!(prod&&prod.available);
    const status=el('div','nxv-wishlist-panel__status'+(!available?' nxv-wishlist-panel__status--sold':''),!prod?'NO LONGER AVAILABLE':available?'CHECK SIZE & COLOR':'CURRENTLY SOLD OUT');
    body.append(status);
    const actions=el('div','nxv-wishlist-panel__actions');
    if(prod){
      const view=el('a','nxv-wishlist-panel__view','VIEW PRODUCT ↗');
      view.href=href(handle);
      actions.append(view);
    }
    const remove=el('button','nxv-wishlist-panel__remove','Remove');
    remove.type='button';
    remove.dataset.nxvWishlistRemove=handle;
    remove.setAttribute('aria-label','Remove '+(prod?prod.title:'unavailable product')+' from wishlist');
    actions.append(remove);
    body.append(actions);
    article.append(imageLink,body);
    return article;
  }
  async function renderPanel(){
    const id=++renderVersion;
    const current=handles.slice();
    if(!current.length){empty();return}
    list.replaceChildren(el('p','nxv-wishlist-panel__status','Loading saved styles…'));
    const out=[];
    for(let i=0;i<current.length;i+=6){
      const chunk=current.slice(i,i+6);
      const values=await Promise.all(chunk.map(loadProduct));
      for(let j=0;j<chunk.length;j++)out.push([chunk[j],values[j]]);
      if(id!==renderVersion||!panel.open)return;
    }
    if(id!==renderVersion||!panel.open)return;
    const grid=el('div','nxv-wishlist-panel__grid');
    out.forEach(([h,p])=>grid.append(productCard(h,p)));
    list.replaceChildren(grid);
  }
  function openPanel(){
    if(!panel.open)panel.showModal();
    renderPanel();
  }
  document.addEventListener('click',event=>{
    if(!(event.target instanceof Element))return;
    const heart=event.target.closest('[data-nxv-wishlist-handle]');
    if(heart){
      event.preventDefault();event.stopPropagation();
      toggle(heart.dataset.nxvWishlistHandle);return;
    }
    const opener=event.target.closest('[data-nxv-wishlist-open]');
    if(opener){event.preventDefault();event.stopPropagation();openPanel();return}
    const closer=event.target.closest('[data-nxv-wishlist-close]');
    if(closer){event.preventDefault();panel.close();return}
    const remover=event.target.closest('[data-nxv-wishlist-remove]');
    if(remover){event.preventDefault();toggle(remover.dataset.nxvWishlistRemove);return}
  },true);
  panel.addEventListener('click',event=>{
    if(event.target===panel)panel.close();
  });
  panel.addEventListener('close',()=>{renderVersion++});
  window.addEventListener('storage',event=>{
    if(event.key===KEY){handles=read();syncControls();if(panel.open)renderPanel()}
  });
  const observer=new MutationObserver(records=>{
    let added=false;
    for(const record of records){
      for(const node of record.addedNodes){
        if(node.nodeType===1&&(node.matches?.('[data-nxv-wishlist-handle]')||node.querySelector?.('[data-nxv-wishlist-handle]'))){added=true;break}
      }
      if(added)break;
    }
    if(added)requestAnimationFrame(syncControls);
  });
  handles=read();syncControls();
  observer.observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',syncControls);
})();